module.exports = __webpack_public_path__ + "static/hero-hcp-safety-c339c340b1e85aba0c6c5c40a0bba938.png";